/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WarehouseResVo } from './WarehouseResVo';
import {
    WarehouseResVoFromJSON,
    WarehouseResVoFromJSONTyped,
    WarehouseResVoToJSON,
    WarehouseResVoToJSONTyped,
} from './WarehouseResVo';

/**
 * 
 * @export
 * @interface ResponseListWarehouseResVo
 */
export interface ResponseListWarehouseResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListWarehouseResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListWarehouseResVo
     */
    message?: string;
    /**
     * 
     * @type {Array<WarehouseResVo>}
     * @memberof ResponseListWarehouseResVo
     */
    data?: Array<WarehouseResVo>;
}

/**
 * Check if a given object implements the ResponseListWarehouseResVo interface.
 */
export function instanceOfResponseListWarehouseResVo(value: object): value is ResponseListWarehouseResVo {
    return true;
}

export function ResponseListWarehouseResVoFromJSON(json: any): ResponseListWarehouseResVo {
    return ResponseListWarehouseResVoFromJSONTyped(json, false);
}

export function ResponseListWarehouseResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListWarehouseResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(WarehouseResVoFromJSON)),
    };
}

export function ResponseListWarehouseResVoToJSON(json: any): ResponseListWarehouseResVo {
    return ResponseListWarehouseResVoToJSONTyped(json, false);
}

export function ResponseListWarehouseResVoToJSONTyped(value?: ResponseListWarehouseResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(WarehouseResVoToJSON)),
    };
}

